import React from 'react';
import SigninTemplate from '../components/template/SigninTemplate';

const SigninScreen: React.FC = () => {
  return <SigninTemplate />;
};

export default SigninScreen;
